(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skrymt-home-window"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skrymt-window')) {
    customElements.define('skrymt-window', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay === 'false';
        this.visible = true;
        this.toggle = this.querySelector('[data-window-toggle]');
        this.colors = Array.from(this.querySelectorAll('[data-window-color]'));
        this.groups = [];
        const featuredImage = this.querySelector('.skrymt-window__image');
        if (featuredImage && this.colors.length) {
          this.addGroup(featuredImage, this.colors.map(button => ({ ...button.dataset })), featuredImage.closest('.skrymt-window__featured'), true);
        }
        for (const [kind, selector] of [['story', '.skrymt-window__story-image'], ['hoodies', '.skrymt-window__category-image']]) {
          const image = this.querySelector(selector);
          const template = this.querySelector(`template[data-window-slides="${kind}"]`);
          if (image && template) {
            const slides = Array.from(template.content.querySelectorAll('[data-image]')).map(slide => ({ ...slide.dataset }));
            this.addGroup(image, slides, image.parentElement, false);
          }
        }
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('[data-window-toggle]')) {
            this.setPaused(!this.paused);
            return;
          }
          const button = event.target.closest('[data-window-color]');
          const group = this.groups.find(item => item.colors);
          if (!button || !group) return;
          const index = this.colors.indexOf(button);
          if (index < 0) return;
          this.setPaused(true);
          this.showSlide(group, index, true);
        }, { signal: this.controller.signal });
        this.onMotionChange = () => this.syncControls();
        this.motion.addEventListener('change', this.onMotionChange);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
        });
        this.observer.observe(this);
        this.syncControls();
        const interval = Math.max(3000, Number(this.dataset.interval) || 4000);
        this.timer = window.setInterval(() => {
          for (const group of this.groups) {
            if (!this.canRotate(group)) continue;
            for (let step = 1; step < group.slides.length; step++) {
              const next = (group.index + step) % group.slides.length;
              if (group.slides[next].failed) continue;
              this.showSlide(group, next, false);
              break;
            }
          }
        }, interval);
      }

      addGroup(image, slides, card, colors) {
        if (!slides.length) return;
        const index = colors ? this.colors.findIndex(button => button.getAttribute('aria-pressed') === 'true') : slides.findIndex(slide => slide.image === image.getAttribute('src'));
        this.groups.push({ image, slides, card, colors, index: Math.max(0, index), request: 0, loading: false });
      }

      canRotate(group) {
        return this.isConnected && this.visible && !document.hidden && !this.paused && !this.motion.matches && !group.loading && group.slides.length > 1 && !group.card.matches(':hover') && !group.card.contains(document.activeElement);
      }

      setPaused(paused) {
        this.paused = paused;
        this.syncControls();
      }

      syncControls() {
        if (!this.toggle) return;
        this.toggle.hidden = this.motion.matches || !this.groups.some(group => group.slides.length > 1);
        const label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.title = label;
        this.toggle.querySelector('[data-window-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-window-play-icon]').hidden = !this.paused;
      }

      async showSlide(group, index, manual) {
        const slide = group.slides[index];
        if (!slide?.image) return;
        const request = ++group.request;
        group.loading = true;
        const nextImage = new Image();
        nextImage.sizes = group.image.sizes;
        if (slide.srcset) nextImage.srcset = slide.srcset;
        nextImage.src = slide.image;
        try {
          await nextImage.decode();
        } catch {
          slide.failed = true;
          if (request === group.request) group.loading = false;
          return;
        }
        if (!this.isConnected || request !== group.request) return;
        group.loading = false;
        if (!manual && !this.canRotate(group)) return;
        if (slide.srcset) group.image.srcset = slide.srcset;
        else group.image.removeAttribute('srcset');
        group.image.src = slide.image;
        group.image.alt = slide.alt || '';
        group.index = index;
        if (!this.motion.matches) group.image.animate([{ opacity: 0.45 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
        if (group.colors) {
          this.colors.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
          const name = this.querySelector('.skrymt-window__color-name');
          if (name) name.textContent = slide.colorName;
          for (const selector of ['.skrymt-window__product-link', '.skrymt-window__product-image']) {
            const link = this.querySelector(selector);
            if (link && slide.url) link.href = slide.url;
          }
          const imageLink = this.querySelector('.skrymt-window__product-image');
          if (imageLink) imageLink.setAttribute('aria-label', slide.alt || '');
          const status = this.querySelector('[data-window-status]');
          if (manual && status) status.textContent = slide.alt || '';
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.onMotionChange);
        for (const group of this.groups || []) group.request++;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
